import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import styled, { injectGlobal } from "react-emotion";
import normalizeCSS from "!raw-loader!normalize.css";
import "simple-line-icons/css/simple-line-icons.css";

import Navbar from "../components/Navbar";
import { colors } from "../consts";

injectGlobal`
  ${normalizeCSS}
  html {
    height: 100%;
  }
  body {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 1.4;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    color: ${colors.text};
  }
  #___gatsby {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  * {
    box-sizing: border-box;
  }

  h1, h2, h3, h4, h5, h6, p, ol, ul {
    margin-top: 0;
  }

  h1 {
    font-weight: 400;
    color: ${colors.primary};
  }

  h2 {

  }

  h3 {
    font-size: 20px;
    font-weight: 400;
    color: ${colors.primary};
  }

  h4 {
    font-size: 18px;
    font-weight: 400;
  }

  h5 {
    font-size: 16px;
    font-weight: 400;
    color: ${colors.primary};
    margin-bottom: 10px;
  }

  h6 {
    text-transform: uppercase;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: ${colors.primaryDark};
    font-size: 12px;
    margin-bottom: 10px;
  }
`;

const Content = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

const TemplateWrapper = props => (
  <React.Fragment>
    <Helmet title="Montana Rental Housing Affordability Map" />
    <Navbar indicators={props.data.markdownRemark.frontmatter.indicators} />
    <Content>{props.children()}</Content>
  </React.Fragment>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export default TemplateWrapper;

export const query = graphql`
  query LayoutQuery {
    markdownRemark(frontmatter: { path: { eq: "/map" } }) {
      ...MapSelector
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js